module.exports = __webpack_public_path__ + "img/booleantv-desktop.a86089f5.png";